<template>
  <div class="modal-content goals-sdginfo-modal">
    <transition appear name="goals-sdginfo-modal" v-on:after-leave="afterLeave">
      <div v-if="show">
        <div class="goals-sdginfo-modal-header">
          <icon :name="currentGoal.code" class="goals-sdginfo-modal-icon"></icon>
          <div class="goals-sdginfo-modal-title"><span v-if="currentGoal.code > 0">{{currentGoal.code}}: </span>{{currentGoal.title}}</div>
        </div>
        <div v-if="currentGoal.subtitle" class="goals-sdginfo-modal-subtitle">{{currentGoal.subtitle}}</div>
        <div v-if="currentGoal.code !== 0" class="tabs">
          <div @click="setActiveTab('FN')" class="tab text-center full-width" :class="{'active': activeTab === 'FN'}">
            <span>{{$t('goals.unInfoDescription')}}</span>
          </div>
          <div @click="setActiveTab('profile')" class="tab text-center full-width" :class="{'active': activeTab === 'profile'}">
            <span>{{profile.name}}</span>
          </div>
        </div>
        <div class="goals-sdginfo-modal-description">
          <div id="goals-sdginfo-modal-text" class="goals-sdginfo-modal-text">
            <div v-if="activeTab === 'profile'">
              <div v-if="currentGoal.profileDescription !== null" v-html="currentGoal.profileDescription"></div>
              <div v-if="currentGoal.profileDescription === null" v-html="$t('goals.noProfileTextConstruction').replace(/#profilename#/g, profile.name)"></div>
            </div>
            <div v-if="activeTab === 'FN'">
              <h1>{{$t('goals.unGoalDescriptionLabel')}}</h1>
              <div v-html="currentGoal.description"></div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'sdg-info-modal',
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      show: true,
      currentGoalCode: this.data.initial,
      activeTab: 'FN'
    }
  },
  computed: {
    ...mapGetters({
      profile: 'getProfile'
    }),
    currentGoal () {
      return this.data.goals[this.currentGoalCode]
    }
  },
  methods: {
    afterLeave () {
      this.show = true
    },
    setActiveTab (tab) {
      this.activeTab = tab
    }
  },
  mounted () {
    if (this.currentGoal.code === 0) {
      this.activeTab = 'FN'
    }
  }
}
</script>
